import React from 'react';
import './ServicesPage.css';
import { Link } from 'react-router-dom';

const ServicesPage = () => {
  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="container">
          <div className="hero-content">
            <h1>Services for students</h1>
            <p>Comprehensive support for your study abroad journey</p>
          </div>
        </div>
      </section>

      {/* Student Counselling Section */}
      <section className="service-section">
        <div className="container">
          <div className="services-content">
            <div className="service-text">
              <h2>Student counselling</h2>
              <p>
                At Edugration, we simplify your study abroad journey through personalized consultations. 
                Our goal is to provide accurate information and guidance to help you make informed decisions.
              </p>
              <p>
                We are partnered with over 230+ educational institutions across Australia, Canada, Denmark, 
                Finland, Ireland, New Zealand, Sweden, the UK & the USA. Our counselors will evaluate your 
                academic achievements, financial situation, and other factors to help you choose the best university for you.
              </p>
              <h3>What we discuss</h3>
            </div>
            <div className="service-image">
              <div className="service-image-placeholder">
                <i className="fas fa-comments"></i>
              </div>
            </div>
          </div>
          
          <div className="service-features">
            <div className="feature-item">
              <div className="feature-number">001</div>
              <div className="feature-content">
                <h4>Academic Assessment</h4>
                <p>We review your academic background and career interests.</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-number">002</div>
              <div className="feature-content">
                <h4>Choosing a Suitable University</h4>
                <p>We assist you in selecting the right university based on your preferences and requirements.</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-number">003</div>
              <div className="feature-content">
                <h4>Scholarship Opportunities</h4>
                <p>We guide you in finding and applying for scholarships based on your academic achievements.</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-number">004</div>
              <div className="feature-content">
                <h4>Financial Planning</h4>
                <p>We help you find affordable study options and plan your education budget.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* University Application Section */}
      <section className="service-section alt">
        <div className="container">
          <div className="services-content">
            <div className="service-text">
              <h2>University Application</h2>
              <p>
                With direct partnerships with <strong>230+ top universities worldwide</strong>, Edugration makes your 
                application process faster, smoother, and more reliable. Our expert counselors work closely with 
                students to ensure every detail of the university application is done right — maximizing your chances of admission.
              </p>
              <h3>What we do</h3>
              <ul className="service-list">
                <li>Match you with the best-fit universities from our 230+ global partners</li>
                <li>Guide you in preparing documents</li>
                <li>Ensure accurate and timely application submissions</li>
                <li>Assist with university ums logins and communication</li>
                <li>Follow up and keep you updated on application progress</li>
              </ul>
              {/* <button className="btn btn-primary">
                Request a callback
                <i className="fas fa-phone"></i>
              </button> */}
            </div>
            <div className="service-image">
              <div className="service-image-placeholder">
                <i className="fas fa-file-alt"></i>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Visa Application Guidance Section */}
      <section className="service-section">
        <div className="container">
          <div className="services-content">
            <div className="service-text">
              <h2>Visa application Guidance</h2>
              <p>
                Once you receive your university offer letter, our dedicated visa team steps in to guide you 
                through the entire student visa process. With years of experience and updated knowledge of visa 
                regulations, we ensure your application is strong, complete, and ready for approval.
              </p>
              <h3>What we do</h3>
              <ul className="service-list">
                <li>Provide a detailed visa document checklist</li>
                <li>Review and verify all required documents</li>
                <li>Train you for the visa interview (if applicable)</li>
                <li>Guide you in preparing financial and sponsor papers</li>
                <li>Submit your visa application and monitor updates</li>
              </ul>
              {/* <button className="btn btn-primary">
                Request a callback
                <i className="fas fa-phone"></i>
              </button> */}
            </div>
            <div className="service-image">
              <div className="service-image-placeholder">
                <i className="fas fa-passport"></i>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Accommodation Advice Section */}
      <section className="service-section alt">
        <div className="container">
          <div className="services-content">
            <div className="service-text">
              <h2>Accommodation Advice</h2>
              <p>
                Finding a safe and comfortable place to live abroad is just as important as getting admission. 
                At Edugration, we help you secure the right accommodation based on your budget, preferences, 
                and university location — so you can settle in with peace of mind.
              </p>
              <h3>What we discuss</h3>
              <ul className="service-list">
                <li>Provide guidance on on-campus and off-campus housing options</li>
                <li>Assist in connecting with verified student accommodation providers</li>
                <li>Help you compare rent, facilities, and locations</li>
                <li>Support in booking your accommodation before you fly</li>
                <li>Share safety tips and local area insights</li>
              </ul>
              {/* <button className="btn btn-primary">
                Request a callback
                <i className="fas fa-phone"></i>
              </button> */}
            </div>
            <div className="service-image">
              <div className="service-image-placeholder">
                <i className="fas fa-home"></i>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pre-Departure Briefing Section */}
      <section className="service-section">
        <div className="container">
          <div className="services-content">
            <div className="service-text">
              <h2>Pre-Departure briefing</h2>
              <p>
                Before you take off, we prepare you for a smooth transition into your new academic and cultural 
                life abroad. Our pre-departure briefing covers everything you need to know — from travel tips to 
                adapting in a new country — so you arrive informed and confident.
              </p>
              <h3>What we discuss</h3>
              <ul className="service-list">
                <li>Share travel guidelines and airport procedures</li>
                <li>Advise on baggage, currency, and essential items to carry</li>
                <li>Discuss cultural differences and student life abroad</li>
                <li>Provide emergency contacts and safety tips</li>
                <li>Connect you with other students heading to the same destination</li>
              </ul>
              {/* <button className="btn btn-primary">
                Request a callback
                <i className="fas fa-phone"></i>
              </button> */}
            </div>
            <div className="service-image">
              <div className="service-image-placeholder">
                <i className="fas fa-plane-departure"></i>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Looking for a one-stop solution?</h2>
            <p>Let us guide you through every step.</p>
            <Link to="/apply">
              <button className="btn btn-primary btn-large">
                Apply now
                <i className="fas fa-arrow-right"></i>
              </button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
